<script setup>

const props = defineProps({
  location: Object
})

const {slugify} = useLocationData();

const getAgeRange = (experiences) => {
  let min = 0, max = 0;
  if (typeof(experiences) !== 'undefined' && experiences.length > 0) {
    experiences.forEach((experience) => {
      if (!min || min > experience.minAge) {
        min = experience.minAge
      }
      if (!max || max < experience.maxAge) {
        max = experience.maxAge
      }
    });
  }
  

  return `Ages ${min}-${max}`
}

const getBlurbTwo = (experiences) => {
  
  if (typeof(experiences) !== 'undefined' && experiences.length > 0) {
    const academy = experiences.find(experience => experience.id == 357002);    
    if (academy) {
      return "Weeklong camps and 2-week academies"
    }
  }
   
  return "Weeklong camps"
}

const getDurationBlurb = (pulseLocation) => {  
  if (pulseLocation.firstSessionStartDate == '' || pulseLocation.lastSessionEndDate == '') {
    return '';
  }

  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const start = new Date(new Date(pulseLocation.firstSessionStartDate).toLocaleString('en', {timeZone: 'UTC'}));
  const end = new Date(new Date(pulseLocation.lastSessionEndDate).toLocaleString('en', {timeZone: 'UTC'}));

  return `Programs run ${monthNames[start.getMonth()]} ${start.getDate()} to ${monthNames[end.getMonth()]} ${end.getDate()}`;
}

const locationImage = props.location.listingImage ? props.location.listingImage.url : null;

</script>
<template>
  <div class="row location" >
    <div class="location-image col-12 col-md-3">
      <NuxtLink :href="location.url">
        <NuxtImg :src="locationImage" class="rounded-4" v-if="locationImage" />
      </NuxtLink>
    </div>
    <div class="col-12 col-md-6">
      <div class="row">
        <div class="col-8">
          <NuxtLink :href="location.url">                    
            <h4 class="location-name">{{ location.pulseLocation.name }}</h4>
          </NuxtLink>
        </div>
          <div class="col-4" v-if="location.distance">
              <div class="location-distance">{{ parseFloat(location.distance).toFixed(2) }} mi</div>
          </div>
      </div>
      <h4 class="location-address">{{ location.pulseLocation.addressArea }}</h4>
        <div v-if="location.pulseLocation.status" :class="`location-status  location-status--${slugify(location.pulseLocation.status.name)}`">
          {{ location.pulseLocation.status.name }}
        </div>
      <ul>
        <li v-if="location.pulseLocation.residencyOption"><span class="info-line" >{{ location.pulseLocation.residencyOption.name }} available</span></li>
        <li v-if="location.pulseLocation.experiences && location.pulseLocation.status && location.pulseLocation.status.typeId == 1"><span class="info-line" >{{ getAgeRange(location.pulseLocation.experiences) }}</span></li>          
        <li v-if="location.pulseLocation.experiences"><span class="info-line" >{{ getBlurbTwo(location.pulseLocation.experiences) }}</span></li>
        <li v-if="location.pulseLocation.experiences && location.pulseLocation.status && location.pulseLocation.status.typeId == 1"><span class="info-line" >{{ getDurationBlurb(location.pulseLocation) }}</span></li>
      </ul>
    </div>
    <div class="col-12 col-md-3 text-center">
        <NuxtLink class="btn btn-primary centered" :href="location.url">Choose Location</NuxtLink>
    </div>
  </div>  
</template>